/**
 * Searchable time-value popover.
 */
export function showTimePopover(picker, $anchor, type, max, current, onChange) {
  const $ = window.jQuery;
  $('.gdp-time-popover').remove();

  const filter = (() => {
    if (type === 'H') return picker.config.filters.hour;
    if (type === 'M') return picker.config.filters.minute;
    if (type === 'S') return picker.config.filters.second;
    return null;
  })();

  const $popover = $('<div class="gdp-time-popover"></div>');
  const $search = $('<input type="text" class="gdp-popover-search" placeholder="Search...">');
  const $list = $('<div class="gdp-popover-list"></div>');

  const renderList = (searchVal = '') => {
    $list.empty();
    for (let i = 0; i <= max; i++) {
      const s = i.toString().padStart(2, '0');
      if (searchVal && !s.includes(searchVal)) continue;
      if (filter && !filter(i)) continue;

      const $item = $(`<div class="gdp-popover-item ${i === current ? 'selected' : ''}">${s}</div>`);
      $item.on('click', () => {
        onChange(i);
        $popover.remove();
        picker._updateContent();
      });
      $list.append($item);
    }
  };

  $search.on('input', (e) => renderList(e.target.value));
  renderList();

  $popover.append($search, $list);
  picker.$container.append($popover);

  const pos = $anchor.position();
  $popover.css({
    top: pos.top + $anchor.outerHeight() + 5,
    left: pos.left + $anchor.outerWidth() / 2 - 35,
  });

  setTimeout(() => $search.focus(), 10);

  const closeHandler = (e) => {
    if (!$popover.is(e.target) && $popover.has(e.target).length === 0 && !$anchor.is(e.target)) {
      $popover.remove();
      $(document).off('click', closeHandler);
    }
  };
  setTimeout(() => $(document).on('click', closeHandler), 10);
}
